import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../pages/HomeView.vue'
import { getLocale } from '@/utils/common/locale'
import RiderConfirmCodeRoute from '@/pages/rider-confirm-code/route'
import ConfirmationEntregaRoute from '@/pages/confirmation-entrega/route'
import AdvertiseRoute from '@/pages/advertise/router'
import IntelligentRoute from '@/pages/intelligent/router'
import DeliveryWorkerVerifyRoute from '@/pages/delivery-worker-verify/router'
import DebugRoute from '@/pages/debug/route'
import ItemBRRoute from '@/pages/dishes-for-br/routes'
import ItemRoute from '@/pages/item-manage/router'
import ReviewsRoute from '@/pages/review/router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  ...RiderConfirmCodeRoute,
  ...ConfirmationEntregaRoute,
  ...AdvertiseRoute,
  ...IntelligentRoute,
  ...DeliveryWorkerVerifyRoute,
  ...DebugRoute,
  ...ItemBRRoute,
  ...ItemRoute,
  ...ReviewsRoute,
]
const router = new VueRouter({
  mode: 'history',
  base: `/${getLocale()}/v2`,
  routes,
})

export default router
